// extracted by mini-css-extract-plugin
module.exports = {"loopGrid":"TradeLoops_loopGrid_Wn3Zp","icon-loop":"TradeLoops_icon-loop_gszPT","loop":"TradeLoops_loop_24SND"};